const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

/**
 * A transition from `from` to `to` that started at `startTime` (ms of
 * performance.now()) and lasts `duration` ms.
 *
 * @typedef {{ from: *, to: *, startTime: number, duration: number }} Transition
 */

/**
 * Ease-out (quadratic) progress of a transition at `now`: fast at the start,
 * slowing down to the end (po-chart-visual-spec.md §12.8).
 *
 * @param {Transition} transition
 * @param {number} now - ms
 * @returns {number} 0..1
 */
export const easeOutProgress = ({ startTime, duration }, now) => {
  const linear = duration > 0 ? clamp((now - startTime) / duration, 0, 1) : 1;

  return 1 - (1 - linear) ** 2;
};

/**
 * @param {Transition|null} transition
 * @param {number} now - ms
 * @returns {boolean} the transition exists and has not reached its end yet
 */
export const isRunning = (transition, now) =>
  Boolean(transition) && now - transition.startTime < transition.duration;

/**
 * @param {number} from
 * @param {number} to
 * @param {number} progress - 0..1
 * @returns {number}
 */
export const interpolate = (from, to, progress) => from + (to - from) * progress;
